import { render, staticRenderFns } from "./courseType.vue?vue&type=template&id=8b2a28a4&scoped=true"
import script from "./courseType.vue?vue&type=script&lang=js"
export * from "./courseType.vue?vue&type=script&lang=js"
import style0 from "./courseType.vue?vue&type=style&index=0&id=8b2a28a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2a28a4",
  null
  
)

export default component.exports